import Vue from 'vue'
import App from './App.vue'
import { auth } from './utils/firebase'
import router from './router'
import PbxxComponent from '@promoboxx/pbxx2component'
import widgets from '@promoboxx/lp-widgets'
import { config } from './utils/config.js'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = `${config['default'].api_base_path}/v2`
Vue.use(VueAxios, axios)
import './styles/index.scss'

import { cloudinary_configuration_options } from './utils/cloudinary'
require('@promoboxx/lp-widgets/dist/lp-widgets.css')
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')
require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
Vue.use(widgets, {cloudinary_configuration_options})
Vue.use(PbxxComponent, {cloudinary_configuration_options})

Vue.config.productionTip = false
let app;
auth.onAuthStateChanged(async function(user) {
  if(app && !user) {
    app.$router.replace('re-route')
  }
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
});
